// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1dG-2","list":"PatternAutocomplete_list__23LGV"};